import { useParams, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { PlayerScorecard } from "../../components/leaderboard/PlayerScorecard";
import { useLeaderboardStore } from "../../store/leaderboardStore";
import { useEffect, useState } from "react";
import { usePublicStore } from "../../store/publicStore";
import { MatchPlayPlayerScorecard } from "../../components/leaderboard/MatchPlayPlayerScoreCard";

export function TeamDetails() {
  const { teamId } = useParams<{ teamId: string }>();
  const { playerLeaderboard, leaderboardMatchId } = useLeaderboardStore();
  const [isMatchPlay, setIsMatchPlay] = useState(false);
  const { matchSetups } = usePublicStore();

  useEffect(() => {
    if (matchSetups && leaderboardMatchId) {
      const matchConfig = matchSetups.find(
        (m) => m.matchId === leaderboardMatchId
      );
      if (matchConfig) {
        setIsMatchPlay(matchConfig.gameFormat === "matchplay");
      }
    }
  }, []);

  const teamPlayers = playerLeaderboard.filter(
    (p) => p.playerForTeamId === teamId
  );
  if (!teamPlayers || teamPlayers.length === 0) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-gray-900">Team not found</h2>
        <Link
          to={
            window.location.pathname.startsWith("/currentSeason")
              ? "/currentSeason/leaderboard"
              : "/leaderboard"
          }
          className="mt-4 inline-flex items-center text-green-600 hover:text-green-900"
        >
          <ChevronLeft className="w-5 h-5 mr-1" />
          Back to Leaderboard
        </Link>
      </div>
    );
  }

  const teamName = teamPlayers[0].playerForTeamName;
  const teamLogo = teamPlayers[0].playerForTeamLogo;
  const totalTeamScore = teamPlayers.reduce(
    (sum, player) =>
      sum + (isMatchPlay ? player.totalPoints : player.totalStableford),
    0
  );

  return (
    <div className="space-y-6 pt-2">
      <div className="flex items-center justify-between">
        <Link
          to={
            window.location.pathname.startsWith("/currentSeason")
              ? "/currentSeason/leaderboard"
              : "/leaderboard"
          }
          className="inline-flex items-center text-gray-700 dark:text-gray-300 cursor-pointer hover:text-gray-900 dark:hover:text-white"
        >
          <ChevronLeft className="w-5 h-5 mr-1" />
          Back to Leaderboard
        </Link>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 mb-6 transition-colors duration-200">
        <div className="flex items-center mb-6">
          {teamLogo && (
            <img
              src={`/api/static/images/${teamLogo}`}
              alt={teamName}
              className="w-16 h-16 rounded-full mr-4"
            />
          )}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              {teamName}
            </h2>
            <div className="flex items-center mt-1 space-x-4">
              <span className="text-gray-600 dark:text-gray-400">
                Total Players: {teamPlayers.length}
              </span>
              <span className="text-gray-600 dark:text-gray-400">
                Total Team Score: {totalTeamScore}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {isMatchPlay &&
          teamPlayers
            .sort((a, b) => b.totalPoints - a.totalPoints)
            .map((player) => (
              <MatchPlayPlayerScorecard key={player.id} player={player} />
            ))}
        {!isMatchPlay &&
          teamPlayers
            .sort((a, b) => b.totalStableford - a.totalStableford)
            .map((player) => (
              <PlayerScorecard key={player.id} player={player} />
            ))}
      </div>
    </div>
  );
}
